
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Countup from 'vux/src/components/countup/index.vue'


export default {
props: ['id'],
components: {
XHeader,
Group,
Cell,
XButton,
Icon,
Actionsheet,
Toast,
Countup
},

data() {
return {
pageLoaded: false,
info: []
}
},
created: function () {
document.title = '订单详情'
this.$vux.loading.show({
'text': '加载中'
});
const url = this.tianYiWebUrl + '/wechat/pickup/ajaxGetDetail';
this.$http.get(url, {params: {id: this.id}}).then(r => {
let res = r.data;
if (res.code === 200) {
this.info = res.data;
this.$vux.loading.hide();
this.pageLoaded = true;
}
})
},
methods: {

agentPay() {
this.doPay()
},
payBalance() {
this.choosePaymentMethod = 'balance'
this.doPay()
},
payWechat() {
this.choosePaymentMethod = 'wechat'
this.doPay()
},

confirm(id) {
const _this = this;
this.$vux.confirm.show({

title: '是否确认提货',
content: '请到店确保拿到货品后再确认提货',
onCancel() {
},
onConfirm() {
_this.$vux.loading.show({
'text': '处理中'
});
_this.doConfirm(id);
}
})
},
doConfirm(id) {
const _this = this;
const url = this.tianYiWebUrl + '/wechat/pickup/confirm';
this.$http.post(url, {orderId: id}).then(r => {
if (r.data.code === 200) {
_this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: r.data.message,
onHide(){
window.location.href = '/html/uc/stockDetail/' + id;
}
})
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: '处理失败'
})
}
})
},
cancel(id) {
const _this = this;
this.$vux.confirm.show({

title: '是否确认取消',
content: '此操作将取消本次提货。',
onConfirm() {
_this.doCancel(id);
}
});
},
doCancel(id) {
this.$vux.loading.show({
'text': '处理中'
});
const url = this.tianYiWebUrl + '/wechat/pickup/cancel'
const _this = this;
this.$http.post(url, {orderId: id}).then(r => {
if (r.data.code === 200) {
_this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: r.data.message,
onHide(){
window.location.href = '/html/uc/stockDetail/' + id;
}
})
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: '取消订单失败'
})
}
})
}

}
}



// WEBPACK FOOTER //
// ./src/components/uc/stockDetail.vue